import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'host-dyn-content-picker',
  templateUrl: './dyn-content-picker.component.html',
  styleUrls: ['./dyn-content-picker.component.scss']
})
export class DynContentPickerComponent implements OnInit {
  @Input() disabled;
  @Input() listOfDynContentOption;
  @Output() onSelect = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

}
